var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',_vm._b({staticClass:"deck-icon",class:{ 'fa-fw': _vm.fixedWidth },style:(_vm.cssProps)},'v-icon',_vm.$attrs,false),[_vm._v("\n  "+_vm._s(`fa-${_vm.computedKind} fa-${_vm.computedName}`)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }